import { AIMSExpansionSection } from '../sections/AIMSExpansionSection';
import { CitationsSection } from '../sections/CitationsSection';
import { HeadlineFindingSection } from '../sections/HeadlineFindingSection';
import { KuduRoleSection } from '../sections/KuduRoleSection';
import { ResearcherQuotesSection } from '../sections/ResearcherQuotesSection';
import { ResearchHeroSection } from '../sections/ResearchHeroSection';
import { ResearchNextStepsSection } from '../sections/ResearchNextStepsSection';
import { StudyAtAGlanceSection } from '../sections/StudyAtAGlanceSection';
import { TwoInterventionsSection } from '../sections/TwoInterventionsSection';

import { useDocumentTitle } from '@/hooks/useDocumentTitle';

import styles from './ResearchPage.module.css';

export function ResearchPage() {
  useDocumentTitle('Research');

  return (
    <div className={styles.page}>
      <ResearchHeroSection />
      <StudyAtAGlanceSection />
      <HeadlineFindingSection />
      <TwoInterventionsSection />
      <ResearcherQuotesSection />
      <AIMSExpansionSection />
      <KuduRoleSection />
      <CitationsSection />
      <ResearchNextStepsSection />
    </div>
  );
}
